import React, { useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { useLocation, useNavigate } from 'react-router';
import DashboardLayout from '../layouts/Dashboard/Dashboard';
import { notifications } from '../components/Dashboard/testData';
import DisaMaturityPage from '../components/MaturityDisaPage/DisaMaturityPage';
import Loading from '../components/Loading/Loading';
import { useCurrentUser } from '../contexts/CurrentUserProvider';
import { setPageTitle } from '../utils/helpers';
import { GET_CUSTOMER_AND_ACCOUNTS } from '../components/DashboardNew/queries/customerAndAccountsQuery';
import { productTypes } from '../utils/productHelpers';
import { fisaMaturityPageSources } from '../components/MaturityNotice/MaturityNoticeConfig';
import { useFeatureFlags } from '../components/FeatureFlags/withFeatureFlags';

const isActiveFisaMaturityWindow = (account) => (
    account?.product?.productType === productTypes.FixedRateCashISA &&
    account?.maturity?.maturityInstructionWindowStatus === 'InstructionOpen' &&
    !account?.maturity?.maturityInstruction
);

const isDisaAccount = (account) => (
    account?.product?.productType === productTypes.InstantAccessCashISA
);

const DisaMaturityPageContainer = () => {
    setPageTitle('Instant Access Cash ISA maturity | Investec Save');

    const location = useLocation();
    const navigate = useNavigate();
    const currentUser = useCurrentUser();
    const [featureEnabled] = useFeatureFlags();
    const { loading, data } = useQuery(GET_CUSTOMER_AND_ACCOUNTS, {
        variables: { id: currentUser ? currentUser.customerId : undefined },
        skip: !currentUser || !currentUser.customerId,
    });

    const products = data?.customer?.products || [];
    const accounts = data?.customer?.accounts || [];
    const source = location.state?.source;
    const isMaturityLearnMoreSource = source === fisaMaturityPageSources.DashboardNotification ||
        source === fisaMaturityPageSources.ManageAccountMaturity;
    const isDisaProductDetailsSource = source === fisaMaturityPageSources.DisaProductDetails;
    const hasActiveFisaMaturityWindow = accounts.some(isActiveFisaMaturityWindow);
    const hasDisaAccount = featureEnabled('EnableFisaMaturity') && accounts.some(isDisaAccount);
    const isMatured = isDisaProductDetailsSource;
    const canAccessPage = ( isMaturityLearnMoreSource && hasActiveFisaMaturityWindow ) || ( isDisaProductDetailsSource && hasDisaAccount );

    useEffect(() => {
        if (!loading && !canAccessPage) {
            navigate('/', { replace: true });
        }
    }, [canAccessPage, loading, navigate]);

    return (
        <DashboardLayout notifications={notifications} fullWidth>
            {loading ? (
                <Loading message="We're loading your maturity information..." />
            ) : !canAccessPage ? null : (
                <DisaMaturityPage products={products} isMatured={isMatured} hasDisaAccount={hasDisaAccount} />
            )}
        </DashboardLayout>
    );
};

export default DisaMaturityPageContainer;
